import { getFeatureFlag } from '@/api'
import { useQuery } from 'react-query'

const keys = {
  featureFlags: 'feature-flags',
}

export const useFeatureFlag = (flagName: string) =>
  useQuery([keys.featureFlags, flagName], () => getFeatureFlag(flagName))
